import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { API_URL, APP_ID, dineInText, pickUpText, DINEIN_ID } from "../../config/constans";
import axios from "axios";
import { getblocks, getOutlets } from "../../stores/cms";
import { getCartItems } from "../../stores/cart";
import { getSetings } from "../../stores/settings";
import { getMenu } from "../../stores/products";
import Header from "../layout/header";
import Footer from "../layout/footer";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import cookie from "react-cookies";
import Select from 'react-select';
import {
	stripslashes,
	getCookies,
	getAliasName,
	getReferenceID,
	customerId,
	showInfo,
	setDeaultcookieValues
} from "../../config/supporters";
import noImage from "../../assets/img/product-no-image.jpg";
import loadingImage from "../../assets/img/spinner.gif";
var _ = require("lodash");
var parse = require('html-react-parser');
var qs = require("qs");
const $ = window.$;
class Menu extends Component {
	constructor(props) {
		super(props);
	
		this.state = {
			menuActive: 0,
			products: [],
			productsLoading: true,
			productsCommon: [],
			currentProduct: null,
			currentProductCategory: null,
			detailstatus: "loading",
			prDetails: {},
			prCommon: {},
			productPrice: '',
			productUnitPrice: 0,
			defaultQty: 1,
			allowCart: "Yes",
			MinMaxSel: 0,
			productName: '',
			product_remarks: "",
			reloadCart: false,
			selected_modifier_value: "",
			multi: false,
			productUnitPrice: 0,
			itemType: 'Simple',
			ModifierCount: '',
			extraComboPrice: 0,
			selected_value: '',
			selectedFile: '',
			giftContent: 'Text',
			dropdownTopHeight: 118,
			renderScreen : 0
		};
	   setDeaultcookieValues();
		this.toggleTabs = this.toggleTabs.bind(this);
		this.handleChangeDescription = this.handleChangeDescription.bind(this);
		this.showProductDetails = this.showProductDetails.bind(this);	
		const outletId = getCookies("orderOutletId");
		const postalcode = getCookies("orderPostalCode");
		const orderAvailability = getCookies("orderAvailability");
		if (outletId === "" || (postalcode === "" && orderAvailability === "")) {
			//showInfo("Please choose outlet first", "");
			//this.props.history.push("/");
			/* cookie.save('enable_order_popup',"Yes"); removed temp      */
			 
				window.location.replace("/");
				return false;
		}

		cookie.save('modiferCount', 0);
		cookie.save('itemType', 'Simple');
		cookie.save('subquantity', 0);
		cookie.save('notsubquantity', "");
		window.addEventListener('scroll', this.handleScroll);

	}

	componentWillMount() {
		

	}
	componentDidMount() {
		
		this.props.getblocks();
		this.props.getOutlets();
		this.props.getMenu();
		this.loadInitialProducts(this.props.navItems);
		
		window.addEventListener('scroll', this.handleScroll);
		/*SCROLL FIXED PRODUCT PAGE*/
		
		/*$(window).scroll(function () {
			var header_height = $('.main-header').offset();

			if (header_height !== undefined) {
				if (parseFloat(header_height.top) > 150) {
					$('.bakery_row_fixed').css('transition', 'all 400ms');
					$('.bakery_row_fixed').css('top', $('.main-header').height());
					$('.bakery_row').addClass('bakery_row_fixed');

				}
				else {
					$('.bakery_row_fixed').css('transition', 'all 400ms');
					$('.bakery_row').removeClass('bakery_row_fixed');

				}
			}
		});*/
		
		$(document).click(function (e) {		
			if (!$(e.target).is(".product-details, .pmodifier_close,  .product-details *, div[id^='react-select-'], .custom_alert, .custom_alert * ")) {
				if ($('.product-details').is(":visible")) {
					$('.product-details').hide(); 
				}
			}
		});
		
	}

	loadInitialProducts(navItems) {
		if (_.isEmpty(navItems) === false) {
			const firstItems = navItems[0];		
			
			const cateSlug  =  (typeof this.props.match.params.proCateSlug !== "undefined" && this.props.match.params.proCateSlug !== ""? this.props.match.params.proCateSlug : "");
			const outputCateSlug = (cateSlug !== ""? cateSlug : firstItems.pro_cate_slug );
			const firstCate = outputCateSlug;
			const firstSubcate = firstItems.pro_subcate_slug;
			this.setState({ currentProductCategory: firstItems.category_name });
			this.getProductDetails(firstCate, firstSubcate);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.menuStatus !== this.props.menuStatus) {
			if (_.isEmpty(nextProps.navItems) === false) {
				const navItems = nextProps.navItems;
				this.loadInitialProducts(navItems);
			}
		}else {
          const thisCateSlug  =  (typeof this.props.match.params.proCateSlug !== "undefined" && this.props.match.params.proCateSlug !== ""? this.props.match.params.proCateSlug : "");
		  const nextCateSlug  =  (typeof nextProps.match.params.proCateSlug !== "undefined" && nextProps.match.params.proCateSlug !== ""? nextProps.match.params.proCateSlug : "");
		  const thisProSlug  =  (typeof this.props.match.params.proslug !== "undefined" && this.props.match.params.proslug !== ""? this.props.match.params.proslug : "");
		  const nextProSlug  =  (typeof nextProps.match.params.proslug !== "undefined" && nextProps.match.params.proslug !== ""? nextProps.match.params.proslug : "");
		   if(thisProSlug !== nextProSlug ){
	           this.getProductDetails(nextCateSlug, "");
			   this.setState({renderScreen : 0});
		   }
		  
		}
	 
	}

	getProductDetails(cateSlug, subCateSlug) {
		
 
		cateSlug =
			typeof cateSlug !== "undefined" && cateSlug !== null ? cateSlug : "";
		subCateSlug =
			typeof subCateSlug !== "undefined" && subCateSlug !== null
				? subCateSlug
				: "";

		var avId = getCookies("orderAvailability");
		var outletID = getCookies("orderOutletId");

		$("#pro_loading").show();
		axios
			.get(
				API_URL +
				"apiv2/products/getAllProducts?app_id=" +
				APP_ID +
				"&availability=" +
				avId +
				"&category_slug=" +
				cateSlug +
				"&subcate_slug=" +
				subCateSlug +
				"&outletId=" +
				outletID
				//"&source_type=Callcenter"
			)
			.then(res => {
				 $("#pro_loading").hide();
				if (res.data.status === "ok") {
							window.scrollTo(0, 0);
					let subcate = res.data.result_set[0];
					let subcateDetails = subcate.subcategorie[0];
					//console.log(subcateDetails);
					if (_.isEmpty(subcateDetails) === false) {
						var pro = _.chunk(subcateDetails.products, 3);
						this.setState({ products: pro, productsCommon: res.data.common, productsLoading: false});
							const proSlug  =  (typeof this.props.match.params.proslug !== "undefined" && this.props.match.params.proslug !== ""? this.props.match.params.proslug : "");
						   if(proSlug !== "" && this.state.renderScreen === 0) {
							   this.showProductDetails(1, proSlug);
							    const dataId =   $("."+cateSlug).data("id");
							   this.setState({renderScreen : 1, menuActive : dataId});
 
						   }
					} else {
						this.setState({ products: [] ,productsLoading: false});
					}
				} else {
					 this.setState({productsLoading: false});
				}
			});
	}

	toggleTabs(tab, cateSlug, subcateSlug, categoryName) {
		this.setState({ menuActive: tab });
		this.setState({ currentProductCategory: categoryName });
		this.getProductDetails(cateSlug, subcateSlug);
	}

	closeModal() {
		$(".product-details").hide();
		this.setState({ defaultQty: 1, product_remarks: "" });
	}

	productReview() {
		return (
			<div className="d-inline-block product-review-line">
				<span className="chef-pr-food" />
				<span className="fas fa-star checked" />
				<span className="fas fa-star checked" />
				<span className="fas fa-star checked" />
				<span className="fas fa-star" />
				<span className="fas fa-star" />
				<Link className="review-link" to="#">
					5 Reviews
        </Link>
			</div>
		);
	}

	showProductDetails(rowIndex, product_slug) {
//console.log(product_slug);
		//	 this.setState({currentProduct : rowIndex }); 

		const productSlug = product_slug;
		const availabilityId = getCookies("orderAvailability");
		axios
			.get(
				API_URL +
				"api/products/products_list?app_id=" +
				APP_ID +
				"&availability=" +
				availabilityId +
				"&product_slug=" +
				productSlug
			)
			.then(res => {
				if (res.data.status === "ok") {

					this.setState({
						detailstatus: "ok",
						prDetails: res.data.result_set[0],
						prCommon: res.data.common,
						productPrice: res.data.result_set[0].product_price,
						productUnitPrice: res.data.result_set[0].product_price,
						MinMaxSel: parseInt(res.data.result_set[0].product_apply_minmax_select),
						productName: res.data.result_set[0].product_name,
						currentProduct: rowIndex
					});
					$(".product-details").show();
					$('html, body').animate({
						scrollTop: $(".product-details").offset().top - ($('header').height() + 30)
					}, 2000);
				} else {
					this.props.history.push("/");
				}
			});

		for (var m = 0, length = 20; m < length; m++) {
			this.setState({ [m]: "" })
			this.setState({ ["modifier" + m]: '' });
		}
	}

	decQty() {
		if (this.state.defaultQty !== 1) {
			this.setState({ defaultQty: this.state.defaultQty - 1 });
		}
	}

	incQty() {

		this.setState({ defaultQty: this.state.defaultQty + 1 });
	}

	addToCart(productID) {
		this.setState({ defaultQty: 1 });
		$(".cart_btn").hide();
		$(".done_btn").show();

	}


	addToCartAction(productId, proName, prosku, proPrice, proQty, proImage, allowCart, applyMinmaxSelect, Validate_mode, productType) {
		var postObject = {};



		var combo = [];
		var modifier = [];
		var comboSelction = "Fail";
		var modifierSelction = "Fail";
		var overAllQty = 0;
		var totalMinSelect = 0;

		if (cookie.load('itemType') === 'Combo' && cookie.load('comboCount') > 0) {

			for (var m = 0, length = cookie.load('comboCount'); m < length; m++) {

				var _items = document.getElementsByClassName("hiddenInput_" + m);
				var selCurQty = 0;
				var _cartQty = 0; var selMincount = 0; var selMaxcount = 0; var selMinSetName = '';

				if (_items.length > 0) {
					var _itemCount = _items.length;
					for (var i = 0; i < _itemCount; i++) {
						selCurQty = parseInt(document.getElementsByClassName('combinput_' + m)[i].innerHTML);
						_cartQty = _cartQty + selCurQty;

					}
				} else {
					selCurQty = parseInt($('.combinput_' + m).html());

					_cartQty = _cartQty + selCurQty;

				}


				overAllQty = overAllQty + _cartQty;
				/* validate min max setup */
				selMincount = parseInt($(".combo-min-" + m).val());

				selMinSetName = $(".combo-min-name" + m).val();
				selMaxcount = parseInt($(".combo-max-" + m).val());

				totalMinSelect = totalMinSelect + selMincount;
				// console.log(_cartQty + "//" + selMincount);
				if (_cartQty < selMincount) {

					showInfo('Please select the min number of items for ' + selMinSetName);

					return false;
				}

				if (_cartQty > selMaxcount) {

					showInfo('Maximum selection limit exceed for ' + selMinSetName);


					return false;
				}

				/* add products  */
				if (overAllQty <= 0 && totalMinSelect > 0) {

					showInfo('Please choose any combo product combination');


					return false;
				}

				var modifierrequired = $("#comboOptionValueModifierRequired_" + m).val();
				var modifierselected = $("#comboOptionValueModifier_" + m).val();

				if (modifierrequired === 'YES' && modifierselected === 'NO') {
					showInfo('Please choose any one shape');

					return false;
				}



				var combovalues = $("#comboOptionValue_" + m).val();

				if (combovalues !== '') {
					var combodetails = JSON.parse(combovalues);
					combo.push(combodetails);

				}


			}
		}


		let API_REQUEST = "";
		if (productType == 1) {

			postObject = {
				app_id: APP_ID,
				product_id: productId,
				product_qty: this.state.defaultQty,
				pageToken: "$%%&(ZCWRT#^FG$%^#D$",
				reference_id: getReferenceID(),
				customer_id: customerId(),
				availability_name: ((getCookies("orderAvailability") === DINEIN_ID) ? dineInText : pickUpText),
				availability_id: getCookies("orderAvailability"),
				product_type: 1,
				outletzone_id: getCookies("orderOutletId"),
				outlet_id: getCookies("orderZoneID"),
				product_remarks: this.state.product_remarks
			};
			API_REQUEST = API_URL + "apiv2/cart/simpleCartInsert";
		} else if (productType == 2) {

			var totalPrice = proQty * proPrice;

			postObject = {
				'app_id': APP_ID,
				"product_id": productId,
				"subquantity": cookie.load('subquantity'),
				"notsubquantity": cookie.load('notsubquantity'),
				"product_name": stripslashes(proName),
				"product_sku": prosku,
				"reference_id": getReferenceID(),
				"customer_id": customerId(),
				"product_image": proImage,
				"availability_id": getCookies("orderAvailability"),
				"product_unit_price": proPrice,
				"product_qty": proQty,
				"product_total_price": totalPrice,
				"modifiers": JSON.stringify(modifier),
				"menu_set_component": JSON.stringify(combo),
				"product_remarks": this.state.product_remarks,
			};

			API_REQUEST = API_URL + "api/cart/insert";
		}


		$("#proLoading").show();
		axios.post(API_REQUEST, qs.stringify(postObject))
			.then(res => {
				$("#proLoading").hide();

				this.setState({ cartAction: true });
				setTimeout(
					function () {
						this.setState({ cartAction: false });
					}.bind(this),
					1000
				);

				if (res.data.status === "ok") {

					cookie.remove("modiferCount");
					cookie.remove("comboCount");
					cookie.remove("itemType");
					$(".done_btn").hide();
					$(".cart_btn").show();
					this.closeModal();
					this.setState({
						defaultQty: 1,
						product_remarks: "",
						cartAlert: true,
						cartAlertMsg: res.data.message,
						reloadCart: true
						/* alertType: SUCCESS_ALERT */
					});

					setTimeout(
						function () {
							this.setState({ reloadCart: false });
						}.bind(this),
						1000
					);
					showInfo(res.data.message);
				} else if (res.data.status === "error") {
					this.setState({
						cartAlert: true,
						cartAlertMsg: res.data.message,
						/*  alertType: FAILURE_ALERT */
					});
					showInfo(res.data.message);
				}
			});
	}

	handleChangeDescription(event) {

		this.setState({ product_remarks: event.target.value });
		//this.setState({ remaining: 30 - event.target.value.length });
	}

	/* ############################# ##############################*/


	/* show combo product option */
	showComboOptions(products, minMaxSelect) {
		cookie.save('comboCount', products.length);
		cookie.save('itemType', 'Combo');

		if (products.length > 0) {

			const html = products.map((item, index) =>

				<div className={(parseInt(item.menu_component_modifier_apply) === 0 && parseInt(minMaxSelect) === 1 ? "product_chosen_item_left product_chosen_item_left_full" : "product_chosen_item_left product_chosen_item_left_full")} key={index}>
					<div className={(parseInt(item.menu_component_modifier_apply) === 0 && parseInt(minMaxSelect) === 1 ? "product_chosen_addons" : '')}>
						<div className="product_chosen_hea">
							<h6>{stripslashes(item.menu_set_component_name)}</h6>
							<span></span>
						</div>
					</div>
					{item.menu_component_min_select >= 1 && <div className="max-min-bar" style={{ display: this.showMinmaxselectionBar(parseInt(item.menu_component_modifier_apply), parseInt(minMaxSelect)) }} >Select {item.menu_component_min_select} Option{item.menu_component_min_select > 1 ? "s" : ""}</div>}
					<div className="max-min-bar" style={{ display: this.showMinmaxBar(parseInt(item.menu_component_modifier_apply), parseInt(minMaxSelect)) }}>You've chosen <span className={"minSele-" + index}>0</span> {item.menu_component_min_select > 1 && "out of " + item.menu_component_min_select} (Max. {item.menu_component_max_select}) </div>
					<input type="hidden" className={"combo-min-" + index} value={item.menu_component_min_select} />
					<input type="hidden" className={"combo-min-name" + index} value={stripslashes(item.menu_set_component_name)} />
					<input type="hidden" className={"combo-max-" + index} value={item.menu_component_max_select} />
					{parseInt(item.menu_component_modifier_apply) === 1 && this.showComboAsDropDown(item.product_details, index, item.menu_set_component_name, item.menu_set_component_id, item.menu_component_pieces_count, item.menu_component_min_select, item.menu_component_max_select, item.menu_component_apply_price)}
					{parseInt(item.menu_component_modifier_apply) === 0 && parseInt(minMaxSelect) === 0 && this.showComboAsDropDown(item.product_details, index, item.menu_set_component_name, item.menu_set_component_id, item.menu_component_pieces_count, item.menu_component_min_select, item.menu_component_max_select, item.menu_component_apply_price)}
					{parseInt(item.menu_component_modifier_apply) === 0 && parseInt(minMaxSelect) === 1 && this.showComboAsCount(item.product_details, index, item.menu_set_component_name, item.menu_set_component_id, item.menu_component_pieces_count, item.menu_component_min_select, item.menu_component_max_select, item.menu_component_apply_price)}

				</div>);
			return html;

		}

	}

	/*  hide minmax bar worksapce */
	showMinmaxBar(val1, val2) {
		return (val1 === 0 && val2 === 1) ? 'block' : "none";

	}


	/*  hide minmax bar worksapce */
	showMinmaxselectionBar(val1, val2) {
		if (val1 === 1) {
			return "block";
		} else if (val1 === 0 && val2 === 1) {
			return "block";
		} else {
			return "none";
		}
	}


	/* show combo product option */
	showCombomodifierName(modifiers, mIndex) {

		if (modifiers) {

			var comboModifier = [];
			$.each(modifiers[0].modifiers_values, function (index, item) {

				var combomodifiervalues = [];
				var combomodifiername = [];
				combomodifiervalues.push({ modifier_value_id: item.pro_modifier_value_id, modifier_value_qty: '1', modifier_value_name: item.pro_modifier_value_name, modifier_value_price: item.pro_modifier_value_price });
				combomodifiername.push({ modifier_id: modifiers[0].pro_modifier_id, modifier_name: modifiers[0].pro_modifier_name.replace(" (Square)", "").replace(" (Both Shapes)", "").replace(" (Round)", ""), modifiers_values: combomodifiervalues });
				comboModifier.push({ mIndex: mIndex, modifier: combomodifiername, value: modifiers[0].pro_modifier_name + "~" + modifiers[0].pro_modifier_id + "~" + item.pro_modifier_value_name + "~" + item.pro_modifier_value_id + "~" + item.pro_modifier_value_modifier_id + "~" + item.pro_modifier_value_price, label: item.pro_modifier_value_name });



			});
			var modifierHtml = (<Select
				value={this.state.selected_modifier_value}
				onChange={this.handleChangeModifier}
				options={comboModifier}
				styles={customStyles} className="react-select-control"
				components={{ DropdownIndicator, IndicatorSeparator: null }}
			/>);

			const html = modifiers.map((item, index) =>
				<div key={index}>
					<div className="product_chosen_hea">
						<h6>{stripslashes(item.pro_modifier_name.replace(" (Square)", "").replace(" (Both Shapes)", "").replace(" (Round)", ""))}</h6>
						<span></span>

					</div>
					<div className="re_select">  {modifierHtml}</div>
				</div>);
			return html;
		} else {
			return ""
		}



	}

	/* show combo product option */
	showCombomodifierOptions(products, mIndex) {

		if (products.length > 0) {
			const html = products.map((item, index) =>
				<div style={{ display: "none" }} className={"select_modifier select_modifier_" + item[0].product_id} key={index}>
					{this.showCombomodifierName(item[0].modifiers, mIndex)}
				</div>);
			return html;

		}

	}

	/* Combo with Count options */
	showComboAsCount(products, mIndex, comboName, comboId, combopieces, minSelect, maxSelect, applyPrice) {
		var comboascountlist = [];
		$.each(products, function (index, item) {


			var product_details = { product_id: item[0].product_id, product_name: (item[0].product_alias !== '' ? stripslashes(item[0].product_alias) : stripslashes(item[0].product_name)), product_sku: item[0].product_sku, product_qty: "1", product_price: item[0].product_price, modifiers: [] };
			var combodetails = { menu_component_id: comboId, menu_component_name: comboName, menu_component_pieces: combopieces };
			comboascountlist.push({ combodetails: combodetails, product_details: product_details })


		});

		const html = products.map((item, index) =>
			<div className="chosen_adn" key={index}>
				<div className="bb-txt2 margin-15 chosen_adn_left">
					<span>{item[0].product_alias !== '' ? stripslashes(item[0].product_alias) : stripslashes(item[0].product_name)}</span>
				</div>
				<div className="radio  pull-right combo-inc-parent chosen_adn_right">
					<div className="qty_bx">
						<span className="qty_minus combo_inc" onClick={this.incComboQty.bind(this, minSelect, maxSelect, mIndex, item[0].product_id + "_" + mIndex + "_" + index, 'remove', item[0].product_price, item[0].product_id, applyPrice, comboascountlist[index])}>-</span>

						<label type="text" id={item[0].product_id + "_" + mIndex + "_" + index} disabled value="0" className={"combo-input-label combo-input combinput_" + mIndex} >0</label>
						<input type="hidden" className={"comboprice_" + mIndex} />
						<input type="hidden" className={"hiddenInput_" + mIndex} defaultValue={item[0].product_price} />

						<input className={item[0].product_id + "_" + mIndex + "_" + index + " css-radio"} type="hidden" value={comboName + "~" + comboId + "~" + (stripslashes((item[0].product_alias !== '' ? stripslashes(item[0].product_alias) : stripslashes(item[0].product_name)))) + "~" + item[0].product_id + "~" + item[0].product_sku + "~" + item[0].product_price} />

						<span className="qty_plus combo_dec" onClick={this.incComboQty.bind(this, minSelect, maxSelect, mIndex, item[0].product_id + "_" + mIndex + "_" + index, 'add', item[0].product_price, item[0].product_id, applyPrice, comboascountlist[index])}>+</span>
					</div>
				</div>
			</div>);

		const countoption = (<div >{html}<input type="hidden" id={"comboOptionValue_" + mIndex} /> <input type="hidden" id={"comboOptionValuePrice_" + mIndex} /></div>);
		return countoption;

	}


	/* Show only Dropdown options */
	showComboAsDropDown(products, mIndex, comboName, comboId, combopieces, minSelect, maxSelect, applyPrice) {

		var comboProducts = [];
		var modLen = 0;
		var multi = false;
		if (maxSelect > 1) {
			multi = true;
		}


		var modifierHtml = '';
		$.each(products, function (index, item) {
			modLen = (item[0].modifiers !== null) ? item[0].modifiers.length : 0;
			var shwPriceHtml = '';
			if (parseFloat(item[0].product_price) > 0 && parseInt(applyPrice) === 1) {
				/* shwPriceHtml = ' (+$' + item[0].product_price + ')'; */
			}


			var product_details = { product_id: item[0].product_id, product_name: (item[0].product_alias !== '' ? stripslashes(item[0].product_alias) : stripslashes(item[0].product_name)), product_sku: item[0].product_sku, product_qty: "1", product_price: item[0].product_price, modifiers: [] };
			var combodetails = { menu_component_id: comboId, menu_component_name: comboName, menu_component_pieces: combopieces };
			comboProducts.push({ subquantity: item[0].product_sub_modifier_qty, product_id: item[0].product_id, product_details: product_details, combodetails: combodetails, value: comboName + "~" + comboId + "~" + (item[0].product_alias !== '' ? stripslashes(item[0].product_alias) : stripslashes(item[0].product_name)) + "~" + item[0].product_id + "~" + item[0].product_sku + "~" + applyPrice + "~" + item[0].product_price, label: item[0].product_alias !== '' ? stripslashes(item[0].product_alias) + shwPriceHtml : stripslashes(item[0].product_name) + shwPriceHtml, modLen: modLen, id: item[0].product_id + "_" + mIndex + "_" + index, mIndex: mIndex, refVal: minSelect + '~' + maxSelect + '~' + mIndex + '~' + item[0].product_id + "_" + mIndex + "_" + index + '~' + item[0].product_price + '~' + item[0].product_id + '~' + applyPrice });

		});

		var modifierHtml = this.showCombomodifierOptions(products, mIndex);
		var dropdown = (<Select styles={customStyles} className="react-select-control" multi={multi} value={this.state.selected_value} components={{ DropdownIndicator, IndicatorSeparator: null }} onChange={this.handleChange} options={comboProducts} />);
		return (<div><div className="form-group"><div className={"re_select re_select_" + mIndex}>{dropdown} <div className="pmodifier_ddlist"><ul>{this.state[mIndex]}</ul></div><label style={{ display: 'none' }} type="text" className={"combo-input combinput_" + mIndex} >0</label>
			<input type="hidden" id={"comboOptionValueModifierRequired_" + mIndex} /><input type="hidden" id={"comboOptionValueModifier_" + mIndex} /><input type="hidden" id={"comboOptionValue_" + mIndex} /><input type="hidden" id={"comboOptionValuePrice_" + mIndex} /></div></div><div className="form-group form-group-modifier"><div className={"re_select_modifier re_select_modifier_" + mIndex}>{modifierHtml}<div className="pmodifier_ddlist"><ul>{this.state["modifier" + mIndex]}</ul></div></div></div></div>);

	}


	updatePriceComboCount() {

		if (cookie.load('itemType') === 'Combo' && cookie.load('comboCount') > 0) {
			var comboprices = 0;
			for (var m = 0, length = cookie.load('comboCount'); m < length; m++) {


				if ($("#comboOptionValuePrice_" + m).val()) {
					comboprices += parseFloat($("#comboOptionValuePrice_" + m).val());
				}

			}

			//console.log(this.state.productUnitPrice + "//" + comboprices);
			var currentPrice = parseFloat(this.state.productUnitPrice) + parseFloat(comboprices);
			this.setState({ productPrice: currentPrice.toFixed(2) })
		}
	}
	/* check min max setup */
	incComboQty(minSelect, maxSelect, setCount, inputId, action, unitPrice, productId, applyPrice, selectedvalue) {
		var productprice = 0;
		var currentPrice = 0;
		var newQty = 0;
		var getQty = parseInt($("#" + inputId).text());
		/* disable if click values is zero*/
		if (getQty <= 0 && action === "remove") {
			return false;
		}
		/* get selected input qty values */
		var items = document.getElementsByClassName("hiddenInput_" + setCount);
		var itemCount = items.length;
		var cartQty = 0;
		for (var i = 0; i < itemCount; i++) {
			cartQty = cartQty + parseInt(document.getElementsByClassName('combinput_' + setCount)[i].innerHTML)


		}



		var addCartQty = cartQty + 1;


		var removeCartQty = (cartQty > 0 ? cartQty - 1 : 0);

		if (addCartQty > maxSelect && action === "add") {
			return false;
		}

		if (action === "add") {
			$(".minSele-" + setCount).html(addCartQty);


		} else if (action === "remove") {
			$(".minSele-" + setCount).html(removeCartQty);
		}
		/*  increase or decrease  product item qty */
		if (action === "remove") {
			newQty = (getQty > 0 ? getQty - 1 : 0);


		} else {
			newQty = getQty + 1;
		}

		$("#" + inputId).text(parseInt(newQty));




		if (applyPrice) {

			var itemprice = parseFloat(unitPrice) * parseInt(newQty);
			$("#" + inputId).next(".comboprice_" + setCount).val(itemprice);
			var lengthcnt = $(".comboprice_" + setCount).length

			var itemprice = 0;
			for (var i = 0; i < lengthcnt; i++) {
				itemprice += parseFloat(document.getElementsByClassName('comboprice_' + setCount)[i].value)

			}
			//console.log(itemprice);
			$(".comboOptionValuePrice_" + setCount).val(itemprice)

			this.updatePriceComboCount();
		}






		var selected = [];
		var combodetails = [];
		var productexist = 0;

		var combovalues = $("#comboOptionValue_" + setCount).val();

		if (combovalues) {
			combodetails = JSON.parse(combovalues);
			if (combodetails.product_details.length) {

				for (var i = 0; i < combodetails.product_details.length; i++) {

					if (combodetails.product_details[i].product_id === productId) {
						productexist = i + 1;

					}

				}

				if (productexist) {
					productexist = parseInt(productexist) - 1;
					combodetails.product_details[productexist].product_qty = parseInt(combodetails.product_details[productexist].product_qty) + 1;
				} else {

					combodetails.product_details.push(selectedvalue.product_details);
				}

			} else {

				combodetails = selectedvalue.combodetails;
				selected.push(selectedvalue.product_details);
				combodetails.product_details = selected
			}
		} else {

			combodetails = selectedvalue.combodetails;
			selected.push(selectedvalue.product_details);
			combodetails.product_details = selected
		}


		$("#comboOptionValue_" + setCount).val(JSON.stringify(combodetails));




	}



	handleChangeModifier = (event) => {
		this.updateCombomodifierSelection(event)
	};


	handleChange = (event) => {
		this.setState({ selected_value: null });	
		if (event.mIndex !== undefined) {
			this.updateComboSelection(event.mIndex, event)
		} else {
			this.updateComboSelection(event[0].mIndex, event)
		}
	};


	removeComboItem(i, applyPrice, indexval) {
		var combodetails = [];
		var combovalues = $("#comboOptionValue_" + indexval).val();
		if (combovalues) {
			combodetails = JSON.parse(combovalues);
			if (combodetails.product_details.length) {
				if (applyPrice) {
					var product_price = parseInt(combodetails.product_details[i].product_qty) * parseFloat(combodetails.product_details[i].product_price);
					var oldPrice = $("#comboOptionValuePrice_" + indexval).val();
					var productprice = parseFloat(oldPrice) - product_price;
					$("#comboOptionValuePrice_" + indexval).val(parseFloat(productprice));
				}
				combodetails.product_details.splice(i, 1);
				var productQty = this.updateProductQty(combodetails.product_details);
				$(".combinput_" + indexval).html(parseInt(productQty));
				$("#comboOptionValue_" + indexval).val(JSON.stringify(combodetails));
			}

		}
		var selectedcombo = this.showSelectedValue(combodetails.product_details, parseInt(applyPrice), indexval);
		this.setState({ [indexval]: selectedcombo })
		this.updatePriceComboCount();

	}

	removeComboModifierItem(indexval) {
		var combodetails = [];
		var combovalues = $("#comboOptionValue_" + indexval).val();
		if (combovalues) {
			combodetails = JSON.parse(combovalues);
			if (combodetails.product_details.length) {
				combodetails.product_details[0].modifier = [];
				$("#comboOptionValue_" + indexval).val(JSON.stringify(combodetails));
				$("#comboOptionValueModifierRequired_" + indexval).val("NO");
				$("#comboOptionValueModifier_" + indexval).val("NO");

			}
			this.setState({ ["modifier" + indexval]: '' });

		}

	}


	updateComboSelection(indexvalues, selectedvalues) {


		var selected = [];
		var combodetails = [];
		var productprice = 0;
		var currentPrice = 0;
		var productexist = 0;

		if (selectedvalues.length || selectedvalues.refVal !== undefined) {
			var indexval = ((selectedvalues[0] === undefined) ? selectedvalues.mIndex : selectedvalues[0].mIndex);
			var combodetails = ((selectedvalues[0] === undefined) ? selectedvalues.combodetails : selectedvalues[0].combodetails);
			if (selectedvalues[0] === undefined) {			
				if (selectedvalues.subquantity != null) {
					cookie.save('subquantity', selectedvalues.subquantity);
					cookie.save('notsubquantity', selectedvalues.product_id);
				}
				var refVal = selectedvalues.refVal.split("~");
				if (parseInt(refVal[6])) {
					productprice += parseFloat(refVal[4]);
				}
				selected.push(selectedvalues.product_details);
				combodetails.product_details = selected
				var selectedcombo = this.showSelectedValue(combodetails.product_details, parseInt(refVal[6]), indexval);
				this.setState({ [indexval]: selectedcombo })


				if (selectedvalues.modLen > 0) {

					$(".re_select_modifier_" + indexval).find(".select_modifier").hide();
					//$(".re_select_modifier_"+indexval).find(".pmodifier_ddlist").hide();
					$("#comboOptionValueModifierRequired_" + indexval).val("YES");
					$("#comboOptionValueModifier_" + indexval).val("NO");
					this.setState({ ["modifier" + indexval]: '' });
					$(".select_modifier_" + selectedvalues.product_id).show();

				} else {

					$(".re_select_modifier_" + indexval).find(".select_modifier").hide();
					$("#comboOptionValueModifierRequired_" + indexval).val("NO");
					$("#comboOptionValueModifier_" + indexval).val("NO");
					this.setState({ ["modifier" + indexval]: '' });

				}

			} else {



				selectedvalues.forEach((selvalue) => {
					var refVal = selvalue.refVal.split("~");
					if (parseInt(refVal[6])) {
						productprice += parseFloat(refVal[4]);
					}
					var productId = refVal[5];
					var combovalues = $("#comboOptionValue_" + indexval).val();
					if (combovalues) {
						combodetails = JSON.parse(combovalues);
						if (combodetails.product_details.length) {

							for (var i = 0; i < combodetails.product_details.length; i++) {

								if (combodetails.product_details[i].product_id === productId) {
									productexist = i + 1;

								}

							}

							if (productexist) {
								productexist = parseInt(productexist) - 1;
								combodetails.product_details[productexist].product_qty = parseInt(combodetails.product_details[productexist].product_qty) + 1;
							} else {

								combodetails.product_details.push(selvalue.product_details);
							}

						} else {

							combodetails = selvalue.combodetails;
							selected.push(selvalue.product_details);
							combodetails.product_details = selected
						}
					} else {

						combodetails = selvalue.combodetails;
						selected.push(selvalue.product_details);
						combodetails.product_details = selected
					}


					var selectedcombo = this.showSelectedValue(combodetails.product_details, parseInt(refVal[6]), indexval);
					this.setState({ [indexval]: selectedcombo })



				});

			}
			$("#comboOptionValuePrice_" + indexval).val(parseFloat(productprice));
			var productQty = this.updateProductQty(combodetails.product_details);
			$(".combinput_" + indexval).html(parseInt(productQty));
			$("#comboOptionValue_" + indexval).val(JSON.stringify(combodetails));
			this.updatePriceComboCount();




		} else {
			currentPrice = parseFloat(this.state.productUnitPrice) + parseFloat(productprice);
			$("#comboOptionValuePrice_" + indexvalues).val(0);
			$("#comboOptionValue_" + indexvalues).val('');
			$(".combinput_" + indexvalues).html(0);
			this.updatePriceComboCount();

		}

	}

	updateCombomodifierSelection(selectedvalues) {

		var selected = [];
		var combodetails = [];
		var indexval = selectedvalues.mIndex;

		var combovalues = $("#comboOptionValue_" + indexval).val();
		if (combovalues) {
			combodetails = JSON.parse(combovalues);

			combodetails.product_details[0].modifiers = selectedvalues.modifier

			$("#comboOptionValue_" + indexval).val(JSON.stringify(combodetails));
			$("#comboOptionValueModifier_" + indexval).val("YES");

			var selectedcombomodifier = this.showSelectedmodifierValue(selectedvalues.modifier[0].modifiers_values, indexval);
			this.setState({ ["modifier" + indexval]: selectedcombomodifier });
		}
	}

	updateProductQty(products) {
		var productQty = 0;
		for (var i = 0; i < products.length; i++) {
			productQty += parseInt(products[i].product_qty);
		}
		return productQty;
	}


	showSelectedmodifierValue(item, indexval) {
		return item.map((item, index) =>
			<li key={index}><span><span>{item.modifier_value_name}</span><a href="javascript:;" onClick={this.removeComboModifierItem.bind(this, indexval)} className="pmodifier_close"></a></span></li>);

	}

	showSelectedValue(products, applyPrice, indexval) {
		return products.map((item, index) =>
			<li key={index + 100}><span><span>{item.product_name}{item.product_qty > 1 && " (" + item.product_qty + ")"} </span><a href="javascript:;" onClick={this.removeComboItem.bind(this, index, applyPrice, indexval)} className="pmodifier_close"></a></span></li>);
		/*	<li key={index + 100}><span><span>{item.product_name}{item.product_qty > 1 && " (" + item.product_qty + ")"} {applyPrice && item.product_price > 0 ? " +$" + (item.product_price * item.product_qty) : ''}</span><a href="javascript:;" onClick={this.removeComboItem.bind(this, index, applyPrice, indexval)} className="pmodifier_close"></a></span></li>); */
	}


	showProductTags(tags) {
		return tags.map((item, index) =>
			<li key={index}><a href={'#/products/tag/' + item.tag_id} target="_blank">{stripslashes(item.pro_tag_name)} {index + 1 !== tags.length ? "/" : ''}  </a></li>);
	}
	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	};
	handleScroll = (event) =>  {
		var header = document.getElementById("bakery_row");
		if (header !== undefined) {
			
		var offsetHeight = document.getElementById('mainNav').offsetHeight;	
		if (window.pageYOffset > 150) {
			header.classList.add("bakery_row_fixed");
			header.style.top = offsetHeight + 'px'; 
		  } else {
			  if($( "#bakery_row" ).hasClass( "bakery_row_fixed" ) === true ){
				header.classList.remove("bakery_row_fixed");
			  }
			
			header.style.top = 0 + 'px'; 
		  }
		}
	  };
	render() {
		
		const productMoreSliderSettings = {
			className: "product-more-slider",
			speed: 500,
			fade: true,
			cssEase: "linear",
			arrows: true,
			lazyLoad: "progressive",
			dots: false
		};
		const menuCategorySliderSettings = {
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: 4,
			slidesToScroll: 4,
			arrows: true,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						infinite: true
					}
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						infinite: true
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}

			]
		};
		const prDetails = this.state.prDetails;
		var proImsgsrc = API_URL + "media/dev_team/products/main-image/";
		const cartImage = (prDetails.product_thumbnail !== "" && typeof prDetails.product_thumbnail !== "undefined" ? proImsgsrc + prDetails.product_thumbnail : "");

		return (
			<React.Fragment>
				<Header allProps={this.props} cartAction={this.state.reloadCart} />
				<main>
					<div className="main-wrapper">
						<section className="inner-page-header">
							<div className="container">
								<div className="page-header-block">								
									<h1 className="font-gothamlight  text-center">OUR MENU</h1>
								</div>
							</div>
						</section>
						<section className="spct-menu-list">
							{/* <div className="container">
              <div className="row menu-category-block">
                <div className="col"><Link className="active" to="#">89th Anniversary Menu</Link></div>
                <div className="col"><Link to="#">Wedding</Link></div>
                <div className="col"><Link to="#">Wedding</Link></div>
                <div className="w-100"></div>
                <div className="col"><Link to="#">89th Anniversary Menu</Link></div>
                <div className="col"><Link to="#">89th Anniversary Menu</Link></div>
                <div className="col"><Link to="#">Wedding</Link></div>
              </div>
            </div> */}
							{_.isEmpty(this.props.navItems) === false && (
								<div className="container">
									<div className="mobile-category-dropdown">
										<div className="dropdown">
											<button className="btn btn-cat-filter dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
												{stripslashes(this.state.currentProductCategory)}
											</button>
											<div className="dropdown-menu scrollable-menu" aria-labelledby="dropdownMenuButton">
												{this.props.navItems.map((cate, cIndex) => (
													<React.Fragment key={cIndex}>

														<Link to="#"
															onClick={() => {
																this.toggleTabs(
																	cIndex,
																	cate.pro_cate_slug,
																	cate.pro_subcate_slug,
																	cate.category_name
																);
															}}
															data-id={cIndex}
															className={
																this.state.menuActive === cIndex ? "dropdown-item active " +cate.pro_cate_slug : "dropdown-item " +cate.pro_cate_slug 
															}
														>
															{stripslashes(
																typeof cate.subcategory_name !== "undefined" &&
																	cate.subcategory_name !== null
																	? cate.subcategory_name
																	: cate.category_name
															)}
														</Link>
													</React.Fragment>
												))}
											</div>
										</div>
									</div>
									<div className="menu-category-block bakery_row" id="bakery_row">

										<Slider {...menuCategorySliderSettings}>
											{this.props.navItems.map((cate, cIndex) => (
												<div className="category-item" key={cIndex}>
													<Link to="#"
														onClick={() => {
															this.toggleTabs(
																cIndex,
																cate.pro_cate_slug,
																cate.pro_subcate_slug,
																cate.category_name
															);
														}}
														className={
															this.state.menuActive === cIndex ? "active" : ""
														}
													>
														{stripslashes(
															typeof cate.subcategory_name !== "undefined" &&
																cate.subcategory_name !== null
																? cate.subcategory_name
																: cate.category_name
														)}
													</Link>
												</div>
											))}
										</Slider>
									</div>
								</div>
							)}
							<div className="container spct-producs-container">
								{_.isEmpty(this.state.products) === false &&
									this.state.products.map((prod, mainIndex) => (
										<React.Fragment key={mainIndex}>
											<div className="row tetst" key={mainIndex}>
												{_.isEmpty(prod) === false &&
													prod.map((pro, proIndex) => (
														<React.Fragment key={proIndex}>
															<div
																key={proIndex}
																className="product-item-colm  col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
															>
																<div className="product-item card">
																	<img src={(pro.product_thumbnail !== ""
																		? this.state.productsCommon.product_image_source + "/" + pro.product_thumbnail
																		: noImage)} alt="" onClick={this.showProductDetails.bind(this, mainIndex, pro.product_slug)} />
																	<div className="card-body">
																		<div className="card-title" onClick={this.showProductDetails.bind(this, mainIndex, pro.product_slug)}>

																			{stripslashes(
																				getAliasName(
																					pro.product_alias,
																					pro.product_name
																				)
																			)}
																		</div>
																		{pro.product_short_description !== null && <span className="menu-set-tag">{pro.product_short_description}</span>}
																		<p className="price-tag card-text">

																			${pro.product_price}
																		</p>
																		<button
																			type="button"
																			className="add-to-btn-cart btn btn-primary btn-block"
																			onClick={this.showProductDetails.bind(this, mainIndex, pro.product_slug)}
																		>
																			Order Now
                                    </button>
																	</div>
																</div>
															</div>
														</React.Fragment>
													))}
											</div>

											{(this.state.currentProduct === mainIndex && this.state.detailstatus === "ok" && _.isEmpty(prDetails) === false) && <div className="product-details"  >
												<button className="product-view-close float-right" onClick={this.closeModal.bind(this)}>close</button>
												<div className="row justify-content-center row-of-product-slider">

													<div className="col-12 col-sm-10 col-md-8" align="center">
														{_.isEmpty(prDetails.image_gallery) === false &&
															<div className="product-slider-block">
																<Slider {...productMoreSliderSettings}>
																	{prDetails.image_gallery.map((slider, sIndex) => (
																		<React.Fragment key={sIndex}>
																			{(slider.pro_gallery_image !== null && slider.pro_gallery_image !== "") && <div className="product-slide"><img src={this.state.prCommon.product_gallery_image_source + "/" + slider.pro_gallery_image} alt="" /></div>}
																		</React.Fragment>
																	))}
																</Slider>
															</div>

														}
													</div>
													<div className={_.isEmpty(prDetails.image_gallery) === true ? "col-12 product-info-colm no-gallery" : "col-12 product-info-colm"}>
														<div className="card mb-3" >
															<div className="card-header bg-transparent">
																<h5 className="font-opnsns text-bold">
																	{stripslashes(getAliasName(prDetails.product_alias, prDetails.product_name))}
																	{/*<span className="product-review-block">{this.productReview("")}</span> */}  </h5>
																{(prDetails.product_long_description !== null) && <p style={{ whiteSpace: 'pre-line' }}>
																	{prDetails.product_long_description}
																</p>}
															</div>
															<div className="card-body">

																<div className="row">
																	<div className="col-12 col-md-6 choosen-product-options-colm left">
																		<div className="product-choosen-item  choose-product-size-block">
																			<div className="product-size-options-block">
																				{prDetails.product_is_combo === 'Yes' && this.showComboOptions(prDetails.set_menu_component, parseInt(prDetails.product_apply_minmax_select))}
																			</div>
																		</div>
																	</div>
																	{/*    <div className="col-12 col-md-6 choosen-product-options-colm left">
                              <div className="product-choosen-item  choose-product-size-block">
                                <div className="product-chosen-header">
                                  <h5 className="font-opnsns text-uppercase">Choose Product Size</h5>
                                  <span></span>
                                </div>
                                <div className="product-size-options-block">
                                  <label className="spct-radio">Modifier Name
                              <input type="radio" defaultChecked="checked" name="radio" />
                                    <span className="checkmark" />
                                  </label>
                                  <label className="spct-radio">Modifier Name
                              <input type="radio" defaultChecked="checked" name="radio" />
                                    <span className="checkmark" />
                                  </label>
                                </div>
                              </div>
                              <div className="product-choosen-item choose-product-addons-block">
                                <div className="product-chosen-header">
                                  <h5 className="font-opnsns text-uppercase">Choose Your Addons</h5>
                                  <span></span>
                                </div>
                                <div className="product-size-options-block">
                                  <div className="chosen-adn">
                                    <div className="bb-txt2 margin-15 chosen-adn-left">
                                      <span>Modifier Name</span>
                                    </div>
                                    <div className="float-right chosen-adn-right">
                                      <div className="qty-bx">
                                        <span className="qty-minus combo-inc">-</span>
                                        <label className="combo-input-label combo-input">4</label>
                                        <span className="qty-plus combo-dec">+</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="chosen-adn">
                                    <div className="bb-txt2 margin-15 chosen-adn-left">
                                      <span>Modifier Name</span>
                                    </div>
                                    <div className="float-right chosen-adn-right">
                                      <div className="qty-bx">
                                        <span className="qty-minus combo-inc">-</span>
                                        <label className="combo-input-label combo-input">4</label>
                                        <span className="qty-plus combo-dec">+</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
					  </div>    */}
																{/*	<div className="col-12 col-md-12 choosen-product-options-colm right">
																		<textarea className="form-control" id="exampleFormControlTextarea1" onChange={this.handleChangeDescription}
																			placeholder="Enter your special message here" rows="3" maxLength="150"
																			value={this.state.product_remarks}></textarea>
																</div> */}
																</div>

															</div>
															<div className="card-footer bg-transparent">
																<h3 className="font-opnsns text-center prd-total-price font-weight-bold mt-2"><sup>$</sup>{ /*prDetails.product_price */} {this.state.productPrice}</h3>
																	{/* <div className="prd-chosen-sub-col ">
																	<div className="prd-chosen-sub-item-left cart-update-div" >
																		<div className="qty-bx done_btn" style={{ display: 'none' }}>
																			<span className="qty-minus" onClick={this.decQty.bind(this)}>-</span>
																			<input type="text" readOnly value={this.state.defaultQty} />
																			<span className="qty-plus" onClick={this.incQty.bind(this)}>+</span>
																		</div>
																	</div>
																	<div className="prd-chosen-sub-item-right cart-update-div done_btn" style={{ display: 'none' }}


																		onClick={this.addToCartAction.bind(this, prDetails.product_id, (prDetails.product_alias !== '' ? stripslashes(prDetails.product_alias) : stripslashes(prDetails.product_name)), prDetails.product_sku, this.state.productPrice, this.state.defaultQty, cartImage, this.state.allowCart, parseInt(prDetails.product_apply_minmax_select), 'Insert', prDetails.product_type)}

																	><button>Done</button></div>
																	<div className="prd-chosen-sub-item-right prd-chosen-item-full cart-add-div" >
																		<button className="btn cart_btn" onClick={this.addToCart.bind(
																			this,
																			prDetails.product_primary_id,
																			prDetails.product_id,
																			prDetails.product_type
																		)}>Add To Cart</button>
																	</div>
																</div> */}
															</div>
														</div>
													</div>
												</div>
											</div>}

										</React.Fragment>
									))}
<div
            id="pro_loading"
            style={{
              display: "none",
              bottom: 0,
              left: 0,
              position: "fixed",
              right: 0,
              top: 0,
              margin: "auto",
              zIndex: 9999,
              background: "rgba(255, 255, 255, 0.8)"
            }}
          >
            <img
              src={loadingImage}
              alt="Loading"
              style={{
                bottom: 0,
                left: 0,
                position: "fixed",
                right: 0,
                top: 0,
                margin: "auto"
              }}
            />
          </div>
								{(_.isEmpty(this.state.products) === true && this.state.productsLoading === false ) && <div style={{ padding: "20px", textAlign: "center", color: "red" }}> <b>No Products Found</b> </div>}

							</div>
						</section>
					</div>
				</main>
				<Footer allProps={this.props} />
			</React.Fragment>
		);
	}
}

const DropdownIndicator = () => (
	<div className="react-select-dropdown">
		<div className="react-select-arrow"></div>
	</div>
);
const customStyles = {
	control: () => ({
		// none of react-select's styles are passed to <Control />
		height: 50,
		padding: '.375rem .75rem'
	})
}
const mapStateToProps = ({ cms, products, cart, settings }) => ({
	staticblocks: cms.staticblocks,
	cmsFetch: cms.cmsFetch,
	outlets: cms.outlets,
	navItems: products.navItems,
	menuStatus: products.menuStatus,
	cartData: cart.returnData,
	cartStatus: cart.isStatus,
	settings: settings.returnData,
	setStatus: settings.isStatus
});
const mapDispatchToProps = dispatch =>
	bindActionCreators({ getblocks, getOutlets, getMenu, getCartItems, getSetings }, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Menu);
